module.exports = __webpack_public_path__ + "static/Montserrat-700-a3b387c93882604792867736aecd56c8.ttf";